
import React from 'react';

const equipment = [
  { icon: 'ri-plug-line', name: '電源', desc: 'ほぼすべての席から利用可能' },
  { icon: 'ri-wifi-line', name: 'Wi‑Fi', desc: '高速インターネット完備' },
  { icon: 'ri-door-closed-line', name: '会議室', desc: '4室（要予約）' },
  { icon: 'ri-user-voice-line', name: '個人ブース', desc: '9室（Web会議対応）' },
  { icon: 'ri-restaurant-2-line', name: 'フードホール', desc: '5F直結・4Fへ持込可' },
  { icon: 'ri-fridge-line', name: 'キッチンスペース', desc: '給湯器・冷蔵庫・シンク' },
  { icon: 'ri-microphone-line', name: '電子レンジ', desc: 'トースターも設置' },
  { icon: 'ri-shield-check-line', name: 'シャワー付きトイレ', desc: '清潔なトイレ完備' },
];

export default function CoworkingEquipment() {
  return (
    <section
      className="py-16 sm:py-24 md:py-32 bg-white"
      aria-labelledby="equipment-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            EQUIPMENT
          </span>
          <h2
            id="equipment-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            設備
          </h2>
          <p className="text-sm sm:text-base text-black/60 font-extralight tracking-wide">
            快適に仕事ができる充実した設備をご用意しています
          </p>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 max-w-4xl mx-auto"
          role="list"
        >
          {equipment.map((item, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-5 sm:p-6 text-center hover:bg-emerald-500/50 transition-colors"
              role="listitem"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/10 rounded-xl mx-auto mb-3">
                <i
                  className={`${item.icon} text-xl text-emerald-600`}
                  aria-hidden="true"
                ></i>
              </div>
              <h3 className="text-sm font-light text-black mb-1 tracking-wide">
                {item.name}
              </h3>
              <p className="text-xs text-black/50 font-extralight tracking-wide">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
